import { render, staticRenderFns } from "./ReadAloudCreateFooter.vue?vue&type=template&id=10b52ab7&scoped=true&"
import script from "./ReadAloudCreateFooter.vue?vue&type=script&lang=js&"
export * from "./ReadAloudCreateFooter.vue?vue&type=script&lang=js&"
import style0 from "./ReadAloudCreateFooter.vue?vue&type=style&index=0&id=10b52ab7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b52ab7",
  null
  
)

export default component.exports